import { Navigate, Route, Routes } from 'react-router-dom';

import { useDashboards } from 'dashboards/hooks/useDashboards';
import { useModal } from 'hooks/useModal';
import { useUserMetrics } from 'dashboards/hooks/useUserMetrics';
import { useTimeRangeParams } from 'dashboards/hooks/useTimeRangeParams';

import EmptyIllustration from 'dashboards/images/dashboard-empty-illustration.svg?react';
import { DashboardView } from 'dashboards/views/DashboardView/DashboardView';
import { EmptyView } from 'components/EmptyView/EmptyView';
import { Loader } from 'components/Loader/Loader';

export function Dashboards() {
  const { data: dashboards, isLoading } = useDashboards();
  const { preset, start, stop, timezone } = useTimeRangeParams();

  const { open } = useModal();

  // Pre-load
  useUserMetrics();

  if (!dashboards || isLoading) {
    return <Loader text="Loading dashboards..." />;
  }

  const [firstDashboard] = dashboards.data;

  const search = new URLSearchParams({
    preset,
    start,
    stop,
    timezone,
  }).toString();

  return (
    <Routes>
      {firstDashboard && (
        <Route
          index
          element={
            <Navigate to={{ pathname: firstDashboard.id, search }} replace />
          }
        />
      )}

      <Route path=":dashboardID" element={<DashboardView />} />

      <Route
        path="*"
        element={
          <EmptyView
            image={EmptyIllustration}
            buttonText="Create Dashboard"
            onButtonClick={() => open('create-dashboard')}
          />
        }
      />
    </Routes>
  );
}
